import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "filter-funnel",
  "use": "filter-funnel-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"filter-funnel\"><path d=\"M3.606 2.75h8.797L7.996 8.262 3.606 2.75zm-2.42-.341c1.777 2.266 5.059 6.466 5.059 6.466v5.25a.88.88 0 00.88.875h1.76a.88.88 0 00.879-.875v-5.25s3.273-4.2 5.05-6.466A.873.873 0 0014.119 1H1.88a.873.873 0 00-.695 1.409z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol